import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Ferie, HolidayView, IndexCard } from '@store/models';
import { AlertService } from 'app/core/alerts/alert.service';
import { formatTime, inputTimeToDecimal } from 'app/shared/time';

@Component({
    selector: 'app-holiday-modal-ui',
    templateUrl: './holiday-modal.component.html',
    styleUrls: ['./holiday-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HolidayModalComponent {
    @Input() userLevel: number;
    @Input() selectedYear: number;
    @Input() users: IndexCard[];
    @Input() holidays: HolidayView[];
    @Output() selectYear = new EventEmitter<number>();
    @Output() saveFerie = new EventEmitter<Ferie>();

    get years(): number[] {
        const firstYear = 2010;
        let lastYear = new Date().getFullYear() + 1;
        const periodArray: number[] = [];
        while (lastYear >= firstYear) {
            periodArray.push(lastYear--);
        }
        return periodArray;
    }

    constructor(
        private activeModal: NgbActiveModal,
        private alert: AlertService
    ) {}

    trackByMid(_index: number, holiday: HolidayView) {
        return holiday.mid;
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    onSelectYear(year: number) {
        this.selectYear.emit(year);
    }

    onInput(holiday: HolidayView, event: any) {
        const timeValue = +inputTimeToDecimal(event.target.value);
        const ferieType = event.target.name;
        if (isNaN(timeValue)) {
            const currentValue = ferieType === 'optjent' ? holiday.optjent : holiday.udenloen;
            event.target.value = formatTime(currentValue);
            event.target.select();
            this.alert.createAlert('Der kan kun indtastes tidsværdier', 'danger');
            return;
        }
        event.target.value = formatTime(timeValue);
        const ferie: Ferie = {
            mid: holiday.mid,
            aar: this.selectedYear,
            timer: ferieType === 'optjent' ? timeValue : holiday.optjent,
            ulon: ferieType === 'udenloen' ? timeValue : holiday.udenloen
        };
        this.saveFerie.emit(ferie);
    }
}
